import type { Tables } from "../types";

/**
 * This function returns the color associated with a given project state.
 * @param state
 * @returns
 */
export function getProjectStateColor(state: Tables<"projects">["state"]) {
	switch (state) {
		case "active":
			return "emerald";
		case "inactive":
			return "gray";
		case "archived":
			return "red";
		default:
			return "gray";
	}
}
